import React from 'react';
import {
  isBedroomOptionDisabled,
  getBedroomsButtonText,
} from '../../utils/formOptions';
import { buildBedroomOptions } from '../../utils/bedroomOptionsUtils';

function BedroomsDropdown({
  maxBedroomsData,
  minBedrooms,
  maxBedrooms,
  onMinBedroomsChange,
  onMaxBedroomsChange,
  isOpen,
  onToggle,
}) {
  const getButtonText = () => getBedroomsButtonText(minBedrooms, maxBedrooms);

  const bedroomOptions = buildBedroomOptions(Number(maxBedroomsData));

  return (
    <fieldset className="md:border-l-2 bg-white h-15 border-[#ebebeb] md:h-full md:bg-none flex items-center justify-center relative">
      <legend className="sr-only">Filters</legend>
      <button
        type="button"
        className="text-sm font-medium flex items-center gap-3 lg:h-15"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        {getButtonText()}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          aria-hidden="true"
          focusable="false"
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}
        >
          <use href="#icon-chevron-down" />
        </svg>
      </button>
      {isOpen && (
        <div className="z-50 absolute w-full xl:w-[calc(100%+4px)] bg-white top-full -left-[2px] p-4 border-2 border-[#ebebeb]">
          <div className="mb-4">
            <label
              className="block font-light text-xs mb-2"
              htmlFor="min-bedrooms"
            >
              Minimum bedrooms
            </label>
            <div className="relative">
              <select
                id="min-bedrooms"
                className="px-3 min-h-[42px] bg-grey-100 w-full border border-[#ebebeb] appearance-none"
                name="min-bedrooms"
                value={minBedrooms}
                onChange={(e) => onMinBedroomsChange(e.target.value)}
              >
                <option value="">No min</option>
                {bedroomOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isBedroomOptionDisabled(
                      option.value,
                      'min',
                      minBedrooms,
                      maxBedrooms
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
          <div>
            <label
              className="block font-light text-xs mb-2"
              htmlFor="max-bedrooms"
            >
              Maximum bedrooms
            </label>
            <div className="relative">
              <select
                id="max-bedrooms"
                className="px-3 min-h-[42px] bg-grey-100 w-full border border-[#ebebeb] appearance-none"
                name="max-bedrooms"
                value={maxBedrooms}
                onChange={(e) => onMaxBedroomsChange(e.target.value)}
              >
                <option value="">No max</option>
                {bedroomOptions.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={isBedroomOptionDisabled(
                      option.value,
                      'max',
                      minBedrooms,
                      maxBedrooms
                    )}
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                aria-hidden="true"
                focusable="false"
                className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
              >
                <use href="#icon-chevron-down" />
              </svg>
            </div>
          </div>
        </div>
      )}
    </fieldset>
  );
}

export default BedroomsDropdown;
